import { createSelector } from 'reselect';
import { initialState } from '../reducers/quickText.reducer';
import { QUICK_TEXTS } from '../constants/quickText.constants';

const selectState = state => state?.[QUICK_TEXTS] || initialState;

const selectQuickTextsData = createSelector(
  selectState,
  state => state.get('data')
);

const selectQuickTextsList = createSelector(
  selectQuickTextsData,
  data => data.toList()
);

export const selectQuickTexts = createSelector(
  selectQuickTextsList,
  texts => texts.sortBy(a => -a.get('id'))
);

export const selectQuickTextsFetched = createSelector(
  selectState,
  state => state.get('fetched')
);